module.exports = __webpack_public_path__ + "static/coffee-2232c256fda009b332aa0e84d4371fea.jpg";